module.exports = __webpack_public_path__ + "img/rotateLeft.e67dea85.png";